<div class="gcontainer bwhite">
  <div class="row g-4 header">
    <div class="col-md-3 col-12">
      <nav aria-label="breadcrumb" class="mt-8">
        <ol class="breadcrumb">
          <li class="breadcrumb-item active breadcrumb cursor" aria-current="page"
            (click)="reDirectUrl('dashboard')" (keypress)="reDirectUrl('dashboard')" tabindex="0">
            Dashboard
          </li>
          <li class="breadcrumb-item active breadcrumb cursor" aria-current="page"
            (click)="reDirectUrl('mixDesignDashboard')" (keypress)="reDirectUrl('mixDesignDashboard')">
            Mix Design Dashboard
          </li>
          <li class="breadcrumb-item active" aria-current="page">
            {{ isEditMode ? 'Gotherm / Edit' : 'Geotherm / New' }}
          </li>
        </ol>
      </nav>

      <h1 class="mat-h1">Geotherm Mix Design{{ mixReferenceId ? ' : ' + mixReferenceId : '' }}</h1>
    </div>
    <div class="col-md-1 d-none d-md-block gap-col"></div>
  </div>
  <div class="row">
    <form [formGroup]="myForm">
      <div class="row g-5">
        <div class="col-md-4 form-card">
          <h3 class="mb-3">Project Information</h3>
          <div class="row">
            <div class="col-md-6 col-12">
              <mat-label class="mat-label">
                {{ getLabel('companyName') }}
                @if (isRequired('companyName')) {
                  <span class="required">*</span>
                }
              </mat-label>
              <mat-form-field appearance="outline" class="mat-form-field-width" hideRequiredMarker>
                <input matInput formControlName="companyName"/>
              </mat-form-field>
            </div>
            <div class="col-md-6 col-12">
              <mat-label class="mat-label">
                {{ getLabel('contactName') }}
                @if (isRequired('contactName')) {
                  <span class="required">*</span>
                }
              </mat-label>
              <mat-form-field appearance="outline" class="mat-form-field-width" hideRequiredMarker>
                <input matInput formControlName="contactName"/>
              </mat-form-field>
            </div>
          </div>
          <div>
            <mat-label class="mat-label">
              {{ getLabel('projectName') }}
              @if (isRequired('projectName')) {
                <span class="required">*</span>
              }
            </mat-label>
            <mat-form-field appearance="outline" class="mat-form-field-width" hideRequiredMarker>
              <input matInput formControlName="projectName"/>
            </mat-form-field>
          </div>
          <div>
            <mat-label class="mat-label">
              {{ getLabel('note') }}
              @if (isRequired('note')) {
                <span class="required">*</span>
              }
            </mat-label>
            <mat-form-field appearance="outline" class="mat-form-field-width" hideRequiredMarker>
              <input matInput formControlName="note"/>
            </mat-form-field>
          </div>

          <div class="row">
            <div class="col-md-6 col-12">
              <mat-label class="mat-label">
                {{ getLabel('countryId') }}
                @if (isRequired('countryId')) {
                  <span class="required">*</span>
                }
              </mat-label>
              <mat-form-field appearance="outline" class="mat-form-field-width">
                <mat-select
                  (selectionChange)="getStates($safeNavigationMigration(myForm.get('countryId')?.value))"
                  formControlName="countryId">
                  @for (country of countries; track country) {
                    <mat-option [value]="country.id">{{ country.name }}</mat-option>
                  }
                </mat-select>
              </mat-form-field>
            </div>

            <div class="col-md-6 col-12">
              <mat-label class="mat-label">
                {{ getLabel('stateId') }}
                @if (isRequired('stateId')) {
                  <span class="required">*</span>
                }
              </mat-label>
              <mat-form-field appearance="outline" class="mat-form-field-width">
                <mat-select
                  (selectionChange)="getCities($safeNavigationMigration(myForm.get('stateId')?.value))"
                  formControlName="stateId">
                  @for (state of states; track state) {
                    <mat-option [value]="state.id">{{ state.name }}</mat-option>
                  }
                </mat-select>
              </mat-form-field>
            </div>
          </div>

          <div class="row">
            <div class="col-md-6 col-12">
              <mat-label class="mat-label">
                {{ getLabel('cityId') }}
                @if (isRequired('cityId')) {
                  <span class="required">*</span>
                }
              </mat-label>
              <mat-form-field appearance="outline" class="mat-form-field-width">
                <mat-select formControlName="cityId">
                  @for (city of cities; track city) {
                    <mat-option [value]="city.id" class="arrow">{{ city.name }}</mat-option>
                  }
                </mat-select>
              </mat-form-field>
            </div>

            <div class="col-md-6 col-12">
              <mat-label class="mat-label">
                {{ getLabel('zipcode') }}
                @if (isRequired('zipcode')) {
                  <span class="required">*</span>
                }
              </mat-label>
              <mat-form-field appearance="outline" class="mat-form-field-width" hideRequiredMarker>
                <input matInput formControlName="zipcode"/>
              </mat-form-field>
            </div>
          </div>
        </div>

        <div class="col-md-4 form-card">
          <h3 class="mb-3">Mix Design Information</h3>
          @if (isEditMode) {
            <div class="row">
              <div class="col-md-6 col-12">
                <mat-label class="mat-label">
                  Geotherm Mix Id
                </mat-label>
                <mat-form-field appearance="outline" class="mat-form-field-width" hideRequiredMarker>
                  <input matInput formControlName="mixId" readonly class="readonly-look"/>
                </mat-form-field>
              </div>
            </div>
          }
          <div class="row">
            <div class="col-md-6 col-12">
              <mat-label class="mat-label">
                {{ getLabel('materialType') }}
                @if (isRequired('materialType')) {
                  <span class="required">*</span>
                }
              </mat-label>
              <mat-form-field appearance="outline" class="mat-form-field-width">
                <input
                  matInput
                  formControlName="materialType"
                  [matAutocomplete]="auto"
                  />
                  <mat-autocomplete #auto="matAutocomplete" autoActiveFirstOption>
                    @for (option of materialOptions; track option) {
                      <mat-option [value]="option">
                        {{ option }}
                      </mat-option>
                    }
                  </mat-autocomplete>
                </mat-form-field>
              </div>
              <div class="col-md-6 col-12">
                <mat-label class="mat-label">
                  {{ getLabel('strength') }} <span class="unit-text">(psi)</span>
                  @if (isRequired('strength')) {
                    <span class="required">*</span>
                  }
                  <a class="grapgh-link" href="javascript:void(0)" (click)="openStrengthPopup()" style="margin-left: 8px; font-size: 0.9em;">
                    W/C Ratio
                  </a>
                </mat-label>
                <mat-form-field appearance="outline" class="mat-form-field-width" hideRequiredMarker>
                  <input matInput formControlName="strength"/>
                </mat-form-field>
              </div>
            </div>
            <div class="row">
              <div class="col-md-6 col-12">
                <mat-label class="mat-label">
                  {{ getLabel('slump') }} <span class="unit-text">(inches)</span>
                  @if (isRequired('slump')) {
                    <span class="required">*</span>
                  }
                </mat-label>
                <mat-form-field appearance="outline" class="mat-form-field-width" hideRequiredMarker>
                  <input matInput formControlName="slump"/>
                </mat-form-field>
              </div>
              <div class="col-md-6 col-12">
                <mat-label class="mat-label">
                  {{ getLabel('timeOfEfflux') }} <span class="unit-text">(seconds)</span>
                  @if (isRequired('timeOfEfflux')) {
                    <span class="required">*</span>
                  }
                </mat-label>
                <mat-form-field appearance="outline" class="mat-form-field-width" hideRequiredMarker>
                  <input matInput type="number" formControlName="timeOfEfflux"/>
                </mat-form-field>
              </div>
            </div>
            <div class="row">
              <div class="col-md-12 col-12">
                <mat-label class="mat-label">
                  {{ getLabel('thermalSpecification') }}
                  @if (isRequired('thermalSpecification')) {
                    <span class="required">*</span>
                  }
                </mat-label>
                <mat-form-field appearance="outline" class="mat-form-field-width" hideRequiredMarker>
                  <input matInput formControlName="thermalSpecification"/>
                </mat-form-field>
              </div>
            </div>
            <div class="row">
              <div class="col-md-6 col-12">
                <mat-label class="mat-label">
                  Date
                </mat-label>
                <mat-form-field appearance="outline" class="mat-form-field-width">
                  <input
                    formControlName="date"
                    [max]="currentDate"
                    class="mat-date-input"
                    readonly
                    matInput
                    [matDatepicker]="picker" />
                    <mat-datepicker-toggle matIconSuffix [for]="picker"></mat-datepicker-toggle>
                    <mat-datepicker #picker></mat-datepicker>
                  </mat-form-field>
                </div>
              </div>
            </div>
            <div class="col-md-4 form-card">
              <h3 class="mb-3">Testing Information</h3>
              <div class="row">
                <div class="col-md-6 col-12">
                  <mat-label class="mat-label">
                    {{ getLabel('moldId 1') }}
                    @if (isRequired('moldId1')) {
                      <span class="required">*</span>
                    }
                  </mat-label>
                  <mat-form-field appearance="outline" class="mat-form-field-width" hideRequiredMarker>
                    <input matInput formControlName="moldId1"/>
                  </mat-form-field>
                </div>
                <div class="col-md-6 col-12">
                  <mat-label class="mat-label">
                    {{ getLabel('moldId 2') }}
                    @if (isRequired('moldId2')) {
                      <span class="required">*</span>
                    }
                  </mat-label>
                  <mat-form-field appearance="outline" class="mat-form-field-width" hideRequiredMarker>
                    <input matInput formControlName="moldId2"/>
                  </mat-form-field>
                </div>
              </div>
              <div class="row">
                <div class="col-md-6 col-12">
                  <div class="row">
                    <div class="col-md-6 col-12">
                      <mat-label class="mat-label">
                        Wet TR 1
                        @if (isRequired('wetTr1')) {
                          <span class="required">*</span>
                        }
                      </mat-label>
                      <mat-form-field appearance="outline" class="mat-form-field-width" hideRequiredMarker>
                        <input matInput type="number" formControlName="wetTr1"/>
                      </mat-form-field>
                    </div>
                    <div class="col-md-6 col-12">
                      <mat-label class="mat-label">
                        Dry TR 1
                        @if (isRequired('dryTr1')) {
                          <span class="required">*</span>
                        }
                      </mat-label>
                      <mat-form-field appearance="outline" class="mat-form-field-width" hideRequiredMarker>
                        <input matInput type="number" formControlName="dryTr1"/>
                      </mat-form-field>
                    </div>
                  </div>
                </div>
                <div class="col-md-6 col-12">
                  <div class="row">
                    <div class="col-md-6 col-12">
                      <mat-label class="mat-label">
                        Wet TR 2
                        @if (isRequired('wetTr2')) {
                          <span class="required">*</span>
                        }
                      </mat-label>
                      <mat-form-field appearance="outline" class="mat-form-field-width" hideRequiredMarker>
                        <input matInput type="number" formControlName="wetTr2"/>
                      </mat-form-field>
                    </div>
                    <div class="col-md-6 col-12">
                      <mat-label class="mat-label">
                        Dry TR 2
                        @if (isRequired('dryTr2')) {
                          <span class="required">*</span>
                        }
                      </mat-label>
                      <mat-form-field appearance="outline" class="mat-form-field-width" hideRequiredMarker>
                        <input matInput type="number" formControlName="dryTr2"/>
                      </mat-form-field>
                    </div>
                  </div>
                </div>
              </div>
              <div class="row">
                <div class="col-md-6 col-12">
                  <mat-label class="mat-label">
                    Wet Test Data
                    @if (isRequired('wetTestData')) {
                      <span class="required">*</span>
                    }
                  </mat-label>
                  <mat-form-field appearance="outline" class="mat-form-field-width" hideRequiredMarker>
                    <input matInput formControlName="wetTestData"/>
                  </mat-form-field>
                </div>
                <div class="col-md-6 col-12">
                  <mat-label class="mat-label">
                    Dry Test Data
                    @if (isRequired('dryTestData')) {
                      <span class="required">*</span>
                    }
                  </mat-label>
                  <mat-form-field appearance="outline" class="mat-form-field-width" hideRequiredMarker>
                    <input matInput formControlName="dryTestData"/>
                  </mat-form-field>
                </div>
              </div>
              <div class="row">
                <div class="col-md-6 col-12">
                  <mat-label class="mat-label">
                    {{ getLabel('moldVolume') }} <span class="unit-text">(cc)</span>
                    @if (isRequired('moldVolume')) {
                      <span class="required">*</span>
                    }
                  </mat-label>
                  <mat-form-field appearance="outline" class="mat-form-field-width" hideRequiredMarker>
                    <input matInput type="number" formControlName="moldVolume"/>
                  </mat-form-field>
                </div>
                <div class="col-md-6 col-12">
                  <mat-label class="mat-label">
                    {{ getLabel('slurryWeight') }} <span class="unit-text">(grams)</span>
                    @if (isRequired('slurryWeight')) {
                      <span class="required">*</span>
                    }
                  </mat-label>
                  <mat-form-field appearance="outline" class="mat-form-field-width" hideRequiredMarker>
                    <input matInput type="number" formControlName="slurryWeight"/>
                  </mat-form-field>
                </div>
              </div>
            </div>
          </div>
        </form>
      </div>
      <div class="row">
        <div class="col-md-6 pt-16">
          <mat-card class="shadow-none">
            <mat-card-content>
              <div class="row">
                <div class="col-md-3">
                  <div class="font-12 text-center">Water / Cement Ratio</div>
                  <h1 class="card-count mb-0 text-center">{{ waterCementRatio }}</h1>
                </div>
                <div class="col-md-3">
                  <div class="font-12 text-center">Compressive Strength(psi)</div>
                  <h1 class="card-count mb-0 text-center">{{ compressiveStrength }}</h1>
                </div>
                <div class="col-md-3">
                  <div class="font-12 text-center">Moisture Content (%)</div>
                  <h1 class="card-count mb-0 text-center">{{ moistureContent }}</h1>
                </div>
                <div class="col-md-3">
                  <div class="font-12 text-center">Dry Density (lb/yd³)</div>
                  <h1 class="card-count mb-0 text-center">{{ dryDensity }}</h1>
                </div>
              </div>
            </mat-card-content>
          </mat-card>
        </div>
        <div class="col-md-6 pt-16">
          <mat-card class="shadow-none">
            <mat-card-content>
              <div class="row">
                <div class="col-md-4">
                  <div class="font-12 text-center">Slurry Density (lb/yd³)</div>
                  <h1 class="mb-0 text-center">{{ slurryDensity }}</h1>
                </div>
                <div class="col-md-4">
                  <div class="font-12 text-center">Total Water(gallons)</div>
                  <h1 class="mb-0 text-center">{{ totalWaterGallons }}</h1>
                </div>
                <div class="col-md-4">
                  <div class="font-12 text-center">Total Cemetatious(grams)</div>
                  <h1 class="mb-0 text-center">{{ totalCementitious }}</h1>
                </div>
              </div>
            </mat-card-content>
          </mat-card>
        </div>
      </div>
      <div class="row">
        <div class="table-wrapper">
          <table mat-table [dataSource]="dataSource" class="mat-elevation-z1 material-table">

            <!-- Material Type -->
            <ng-container matColumnDef="materialType">
              <th mat-header-cell *matHeaderCellDef style="width: 11%">Component Material Type *</th>
              <td mat-cell *matCellDef="let row" [formGroup]="row">
                <mat-form-field appearance="outline" class="mat-form-field-width mat-no-label">
                  <mat-select formControlName="materialType">
                    @for (type of materialTypes; track type) {
                      <mat-option [value]="type">
                        {{ type }}
                      </mat-option>
                    }
                  </mat-select>
                </mat-form-field>
              </td>
              <td mat-footer-cell *matFooterCellDef></td>
            </ng-container>

            <!-- Supplier -->
            <ng-container matColumnDef="supplier">
              <th mat-header-cell *matHeaderCellDef style="width: 10%;">Supplier Name</th>
              <td mat-cell *matCellDef="let row" [formGroup]="row">
                <mat-form-field appearance="outline" class="mat-form-field-width mat-no-label">
                  <input matInput formControlName="supplier" />
                </mat-form-field>
              </td>
              <td mat-footer-cell *matFooterCellDef></td>
            </ng-container>

            <!-- Description -->
            <ng-container matColumnDef="description">
              <th mat-header-cell *matHeaderCellDef style="width: 11%;">Supplier Material Name *</th>
              <td mat-cell *matCellDef="let row" [formGroup]="row">
                <mat-form-field appearance="outline" class="mat-form-field-width mat-no-label">
                  <input matInput formControlName="description" />
                </mat-form-field>
              </td>
              <td mat-footer-cell *matFooterCellDef>
                <div style="text-align: right; font-weight: bold;">
                  Total <br><br>
                  Total Water <br><br>
                  Total Dry Weight
                </div>
              </td>
            </ng-container>

            <!-- Repeated Weight Columns -->
            @for (w of [1,2,3,4,5,6,7,8]; track w) {
              <ng-container [matColumnDef]="'weight' + w">
                <th mat-header-cell *matHeaderCellDef class="center-header" style="width: 4%;">{{ w }}</th>
                <td mat-cell *matCellDef="let row" [formGroup]="row">
                  <mat-form-field appearance="outline" class="mat-form-field-width mat-no-label">
                    <input matInput type="number" [formControlName]="'weight' + w" />
                  </mat-form-field>
                </td>
                <td mat-footer-cell *matFooterCellDef></td>
              </ng-container>
            }

            <!-- Weight -->
            <ng-container matColumnDef="weight">
              <th mat-header-cell *matHeaderCellDef class="center-header">
                Weight <span class="unit-text">(lb/yd³)</span> *
              </th>
              <td mat-cell *matCellDef="let row" [formGroup]="row">
                <mat-form-field appearance="outline" class="mat-form-field-width mat-no-label" style="position: relative;">
                  <input
                    matInput
                    type="number"
                    formControlName="weight"
                    />
                    <!-- Show oz/yd³ for Add Mixer rows only -->
                    @if (row.get('materialType')?.value === 'Add Mixer') {
                      <span
                style="
                  position: absolute;
                  right: 2px;
                  top: 45%;
                  transform: translateY(-45%);
                  font-size: 0.75rem;
                  color: rgba(0,0,0,0.6);
                  pointer-events: none;
                "
                        >
                        oz/yd³
                      </span>
                    }
                  </mat-form-field>
                </td>
                <td mat-footer-cell *matFooterCellDef>
                  {{ getTotal('weight') }}<br><br>{{ totalWater }}<br><br>{{ totalDryWeight }}
                </td>
              </ng-container>

              <!-- Dry Weight -->
              <ng-container matColumnDef="dryWeight">
                <th mat-header-cell *matHeaderCellDef class="center-header" style="width: 6%;">Dry Weight<span class="unit-text-next-line">(lb/yd³)</span></th>
                <td mat-cell *matCellDef="let row" [formGroup]="row">
                  <mat-form-field appearance="outline" class="mat-form-field-width mat-no-label">
                    <input matInput type="number" formControlName="dryWeight" />
                  </mat-form-field>
                </td>
                <td mat-footer-cell *matFooterCellDef>{{ getTotal('dryWeight') }}<br><br>{{ totalWaterLbYd3 }}<br><br>{{ totalDryWeightLbYd3 }}</td>
              </ng-container>

              <!-- % -->
              <ng-container matColumnDef="precentage">
                <th mat-header-cell *matHeaderCellDef class="center-header" style="width: 6%;">%</th>
                <td mat-cell *matCellDef="let row" [formGroup]="row">
                  <mat-form-field appearance="outline" class="mat-form-field-width mat-no-label">
                    <input matInput type="number" formControlName="precentage" />
                  </mat-form-field>
                </td>
                <td mat-footer-cell *matFooterCellDef>{{ getTotal('precentage') }}<br><br>{{ '-' }}<br><br>{{ '-' }}</td>
              </ng-container>

              <!-- Specific Gravity -->
              <ng-container matColumnDef="gravity">
                <th mat-header-cell *matHeaderCellDef style="width: 6%;">Specific Gravity</th>
                <td mat-cell *matCellDef="let row" [formGroup]="row">
                  <mat-form-field appearance="outline" class="mat-form-field-width mat-no-label">
                    <input matInput type="number" formControlName="gravity" />
                  </mat-form-field>
                </td>
                <td mat-footer-cell *matFooterCellDef></td>
              </ng-container>

              <!-- Volume -->
              <ng-container matColumnDef="volume">
                <th mat-header-cell *matHeaderCellDef class="center-header" style="width: 6%;">Volume</th>
                <td mat-cell *matCellDef="let row" [formGroup]="row">
                  <mat-form-field appearance="outline" class="mat-form-field-width mat-no-label">
                    <input matInput type="number" formControlName="volume" />
                  </mat-form-field>
                </td>
                <td mat-footer-cell *matFooterCellDef>{{ getTotal('volume') }}<br><br>{{ '-' }}<br><br>{{ '-' }}</td>
              </ng-container>

              <!-- Actions -->
              <ng-container matColumnDef="actions">
                <th mat-header-cell *matHeaderCellDef>Actions</th>
                <td mat-cell *matCellDef="let row; let i = index">
                  <button mat-icon-button class="gray-icon-button" (click)="removeRow(i)">
                    <mat-icon>delete</mat-icon>
                  </button>
                </td>
                <td mat-footer-cell *matFooterCellDef></td>
              </ng-container>

              <!-- Header / Body / Footer Rows -->
              <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
              <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>
              <tr mat-footer-row *matFooterRowDef="displayedColumns"></tr>
            </table>

            <div class="mt-2">
              <button mat-raised-button type="button" (click)="addMaterialRow()">Add Component Material</button>
            </div>
            <div class="mt-3" style="display: flex; justify-content: flex-end; gap: 10px;">
              <button mat-raised-button class="cancel-btn" (click)="cancel()">Cancel</button>
              <button mat-flat-button color="primary" type="submit" [disabled]="myForm.invalid" (click)="onSubmit()">
                {{ isEditMode ? 'Update' : 'Save' }}
              </button>
            </div>
          </div>
        </div>
      </div>
